/**
 * Central definition of all onboarding wizard steps.
 * Import this wherever step metadata is needed.
 */

export interface WizardStepMeta {
  id: number;
  name: string;
  sidebarDescription: string;
  route: string;   // where Edit ↗ navigates to on the Completion screen
  stage: string;   // stage group label shown in the sidebar
}

export const WIZARD_STEPS: WizardStepMeta[] = [
  // ── Stage: Getting Started ───────────────────────────────────────────────
  {
    id: 1,
    name: 'Integrations',
    sidebarDescription: 'Connect external systems',
    route: '/settings/integrations',
    stage: 'Getting Started',
  },
  {
    id: 2,
    name: 'Company Setup',
    sidebarDescription: 'Your organisation details',
    route: '/settings/general',
    stage: 'Getting Started',
  },

  // ── Stage: Finance & Reporting ───────────────────────────────────────────
  {
    id: 3,
    name: 'Finance & Reporting',
    sidebarDescription: 'GP method & revenue mode',
    route: '/settings/general?tab=reporting',
    stage: 'Finance & Reporting',
  },
  {
    id: 4,
    name: 'Targets',
    sidebarDescription: 'Firm-wide benchmark targets',
    route: '/settings/general?tab=targets',
    stage: 'Finance & Reporting',
  },

  // ── Stage: Project Configuration ─────────────────────────────────────────
  {
    id: 5,
    name: 'Project Creation',
    sidebarDescription: 'Numbering & required fields',
    route: '/settings/project?tab=project-creation',
    stage: 'Project Configuration',
  },
  {
    id: 6,
    name: 'Budget Settings',
    sidebarDescription: 'Budget mode & categories',
    route: '/settings/project?tab=budget-settings',
    stage: 'Project Configuration',
  },
  {
    id: 7,
    name: 'Health Thresholds',
    sidebarDescription: 'RAG thresholds & health rules',
    route: '/settings/project?tab=thresholds',
    stage: 'Project Configuration',
  },
  {
    id: 8,
    name: 'Billing Setup',
    sidebarDescription: 'Invoice numbering & aged WIP',
    route: '/settings/project?tab=billing',
    stage: 'Project Configuration',
  },
  {
    id: 9,
    name: 'Project Fields',
    sidebarDescription: 'Custom fields & content sections',
    route: '/settings/project?tab=project-fields',
    stage: 'Project Configuration',
  },
  {
    id: 10,
    name: 'Key People',
    sidebarDescription: 'Accountability roles',
    route: '/settings/project?tab=key-people',
    stage: 'Project Configuration',
  },

  // ── Stage: Users & Access ────────────────────────────────────────────────
  {
    id: 11,
    name: 'User Permissions',
    sidebarDescription: 'Roles & access levels',
    route: '/settings/user-permissions',
    stage: 'Users & Access',
  },

  // ── Stage: Templates & Comms ─────────────────────────────────────────────
  {
    id: 12,
    name: 'Invoice Templates',
    sidebarDescription: 'Invoice layouts & styles',
    route: '/settings/templates',
    stage: 'Templates & Comms',
  },
  {
    id: 13,
    name: 'Email Templates',
    sidebarDescription: 'Automated billing emails',
    route: '/settings/templates',
    stage: 'Templates & Comms',
  },
  {
    id: 14,
    name: 'Notifications',
    sidebarDescription: 'Alerts & scheduling',
    route: '/settings/notifications',
    stage: 'Templates & Comms',
  },
];

export const TOTAL_STEPS = WIZARD_STEPS.length;

/** Step index 0 = Welcome, 1–N = setup steps, N+1 = Completion */
export const WELCOME_STEP = 0;
export const COMPLETION_STEP = TOTAL_STEPS + 1;
